import notiwind from 'notiwind'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(notiwind)
})
